import React, { Fragment } from 'react'
import RecipientSelection from './RecipientSelection'
import { Form } from 'react-bootstrap';


export default function UserHomeNav({userInfo:{userName,userType,recipients}, loggedInFlag, selectedRecipientId, handleRecipientChange}) {
    return (
        <Fragment>
            <div className="navbar-brand">Welcome to the PCRB/DCRB
                            <br/>
                            Correspondence Manager
            </div> 
            {renderLoginMessage(userName, loggedInFlag)}
            <br/>
            {renderRecipientSection(recipients,selectedRecipientId,handleRecipientChange, userType)}

        </Fragment>

    )
}




const renderLoginMessage=(userName, loggedInFlag)=>{

    if(loggedInFlag)
        return(
            <div className="navbar-welcome">
                Welcome {userName} !
            </div>
        );
}



const renderRecipientSection=(recipients,selectedRecipientId,handleRecipientChange, userType)=>{

    if(userType=="PCRBAdmin")   
        return renderAdminRecipientSelection(recipients,selectedRecipientId,handleRecipientChange, userType);
    else
        return renderCarrierOrEmployerRecipientSection(recipients,selectedRecipientId,handleRecipientChange);
}


const renderAdminRecipientSelection=(recipients,selectedRecipientId,handleRecipientChange, userType)=>{
    return(
            <RecipientSelection handleUserSelected={(recipient,_, userType)=>recipient && handleRecipientChange(recipient.id,userType)} returnUrl={""}>                
            </RecipientSelection>                   
    )
}



const renderCarrierOrEmployerRecipientSection=(recipients,selectedRecipientId,handleRecipientChange)=>{
    if(recipients && selectedRecipientId){
        if(recipients.length===1) 
            return <div className="navbar-welcome"><label>View forms for: {recipients[0].name}</label></div>;
        else 
            return(
                <Form.Group className="new-form-controls">
                    <Form.Label>View forms for: </Form.Label>
                        <Form.Control as="select"
                        value={selectedRecipientId}
                
                        onChange={(e,f)=>handleRecipientChange(e.target.value)}>{
                            recipients.map((item) => {
                                return (<option key={item.name} value={item.id}>{item.name}</option>)                        
                            })
                        }   
                    </Form.Control>
                </Form.Group>)
    }
}

